import React, { useEffect, useState } from "react";
import { useSelector,useDispatch  } from "react-redux";
import { homeApi, previewApi } from "../../Services/HomeService";
import { BLOCKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
import { PageTitle } from "../../utils/common";
import { useScrollToSection } from "../../hooks/useScrollToSection";
import { setRates, setContactCopenhagen, setContactBillund, setServices, setFaq, setLocation, setAboutUsBanner, setAboutUsContent, setHomepageData, setCertificates } from "../../store/actions";
import { sanitizeAPIResponse } from "../../utils/sanitizer";
import Banner from "../TopComponents/BannerComponent";
import MainBanner from "../TopComponents/MainBanner";
import LocationCards from "./LocationCards";
import ServicesSection from "./ServicesSection";
import NewsSection from "./NewsSection";
import CertificatesSection from "./CertificatesSection";
import ContactSection from "./ContactSection";
import FooterSection from "./FooterSection";
import classes from "./Test.module.css";
import "../../assets/mobirise/css/mbr-additional.css";
import "../../assets/theme/css/style.css";
import "../../assets/theme/css/main.css";
import '../../App.css';

const Test = (props) => {
  useScrollToSection({ scrollToTop: false });
  const dispatch = useDispatch();
  const url = useSelector((state) => state.url);
  const [home, setHome] = useState(null);
  const [openIndex, setOpenIndex] = useState(0);
  const [isPdfModalOpen, setIsPdfModalOpen] = useState(false);
  const [selectedLocation, setSelectedLocation] = useState('');

  const handleClick = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleRatesClick = (location) => {
    setSelectedLocation(location);
    setIsPdfModalOpen(true);
  };

  const handleClosePdfModal = () => {
    setIsPdfModalOpen(false);
    setSelectedLocation('');
  };

  const HEADING_1 = ({ children }) => (
    <h1 className="">{children}</h1>
  );

  const options = {
    renderNode: {
      [BLOCKS.HEADING_1]: (node, children) => (
        <HEADING_1 className="">{children}</HEADING_1>
      ),
      [BLOCKS.PARAGRAPH]: (node, children) => (
        <p className={paragraphClass(node)}>{children}
        </p>
      ),
      [BLOCKS.BOLD]: (node, children) => (
        <>{children}</>
      ),
    },
  };
  function paragraphClass(node) {
    return classes.cardServiceText;
  }

  useEffect(() => {
    const fetchData = async () => {
      let rawData;
      const queryParams = new URLSearchParams(window.location.search);
      const val = queryParams.get("v") || "";
      if (val === "preview") {
        rawData = await previewApi(url);
      } else {
        rawData = await homeApi(url);
      }

      // Sanitize all data before storing in state and Redux
      const homeData = sanitizeAPIResponse(rawData);

      PageTitle(homeData?.PageTitle);
      setHome(homeData);
      // Store homepage data in Redux
      dispatch(setHomepageData({
        PageTitle: homeData?.PageTitle,
        BannerText: homeData?.BannerText,
        HomeText: homeData?.HomeText,
        HomeBannerText: homeData?.HomeBannerText,
        Image: homeData?.Image
      }));

      // Extract rates and store globally
      const CphRates = homeData?.CphRates?.map((data) => ({
        Title: data.Title,
        File: data.File
      })) || [];

      const BillundRates = homeData?.BillundRates?.map((data) => ({
        Title: data.Title,
        File: data.File
      })) || [];

      dispatch(setRates(CphRates, BillundRates));

      const ContactCopenhagen = homeData?.ContactCopenhagen || {};
      dispatch(setContactCopenhagen(ContactCopenhagen)); 
      

      const ContactBillund = homeData?.ContactBillund || {};
      dispatch(setContactBillund(ContactBillund)); 
      

      const AboutUsBanner = homeData?.AboutUsBanner || {};
      dispatch(setAboutUsBanner(AboutUsBanner));

      const AboutUsContent = homeData?.AboutUsContent || [];
      dispatch(setAboutUsContent(AboutUsContent));

      const Certificates = homeData?.Certificates || [];
      dispatch(setCertificates(Certificates));

      const Services = homeData?.Services || [];
      dispatch(setServices(Services));
    };

    fetchData();
  }, [url, dispatch]);

  const services = home?.Services || [];

  return (
    <div>
      <Banner />
      <MainBanner />
      <LocationCards handleRatesClick={handleRatesClick} />
      <ServicesSection 
        services={services} 
        options={options} 
        handleClick={handleClick} 
      />
      {/* <NewsSection /> */}
      <div style={{height:"120px",backgroundColor:"white"}}></div>
      <CertificatesSection />
      {/* <ContactSection /> */}
      <FooterSection />
    </div>
  );
};

export default Test;